/**
 * @voltxampere/ui — DIP-28 breakout variant (Sprint 47.5-2, placeholder)
 *
 * PLACEHOLDER. DIP-28 to breadboard adapter for ATmega328P /
 * ATmega168 chips without a board. Sprint 47.5 MVP renders as a
 * generic mcu-execution component with atmega328p family defaults;
 * Sprint 51 polish may add bare-chip-only variant (no USB + no
 * regulator + manual power supply).
 *
 * Reference: Generic 28-pin DIP breakout PCB (e.g. SchmartBoard,
 * Adafruit DIP-28 adapter). Pin pitch 2.54mm, breadboard friendly.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuBreakoutDip28 = {
    id: "breakout-dip28",
    nameTr: "DIP-28 Breakout (ATmega328P/168 bare chip, placeholder)",
    nameEn: "DIP-28 Breakout (ATmega328P/168 bare chip, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "DIP-28",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega328p",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-breakout-dip28.js.map